import axiosIns from '@/plugins/axios'

/**
 * 集計テンプレート（UserAggregationAssignTemplate）API クライアント（店舗ユーザー向け）。
 *
 * データ整合性診断の「集計表未所属」ユーザを、その場で集計表へ登録するために使う。
 * バックエンドは eod_closing の権限体系（read: aggregations / create: aggregation_users）。
 */
export default {
  /**
   * 自店舗の集計テンプレート一覧を取得する。
   * レスポンスは employee/user_management 版と同じ JSONAPI 形式
   * （data.data[].attributes: name / aggregationCount / aggregations）。
   */
  getTemplates() {
    return axiosIns.get('/v2/eod_closing/user_aggregation_assign_templates')
  },

  /**
   * テンプレートをユーザに適用し、含まれる集計表・コンテナ・レポートへ一括登録する。
   * 既に所属している集計表はスキップされる（冪等）。
   * @param {number|string} templateId - 集計テンプレートID
   * @param {number|string} userId - 登録するユーザID
   */
  assignUser(templateId, userId) {
    return axiosIns.post(`/v2/eod_closing/user_aggregation_assign_templates/${templateId}/assign`, {
      user_id: userId,
    })
  },
}
